import React from "react";
import gsap from "gsap";
import close from "../images/closeBlanco.svg";

class ModalVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVideoIsOpened: false,
      currentVideoURL: "",
    };
    this.modalContainer = React.createRef();
    this.videoEl = React.createRef();
    this.tweenIn = null;
  }

  componentDidMount() {}
  componentDidUpdate() {}

  openModalVideoBox = (url) => {
    this.setState({ currentVideoURL: url, modalVideoIsOpened: true });
    if (this.tweenIn) this.tweenIn.kill();
    this.tweenIn = gsap.to(this.modalContainer.current, {
      duration: 0.6,
      opacity: 1,
      width: "100%",
      height: "100%",
      top: "0px",
      left: "0px",
      ease: "power4.inOut",
      onComplete: () => {
        this.videoEl.current.currentTime = 0;
        this.videoEl.current.play();
      },
    });
    this.videoEl.current.load();
  };

  closeModalVideo = (event) => {
    event.preventDefault();
    if (this.tweenIn) this.tweenIn.kill();

    const video = this.videoEl.current;
    video.pause();

    this.setState({ modalVideoIsOpened: false });
    if (this.props["close-completion"]) this.props["close-completion"]();
  };

  render() {
    return (
      <div
        id="modal-video"
        ref={this.modalContainer}
        style={
          this.state.modalVideoIsOpened
            ? { display: "block", opacity: "0", background: "#000", top: "-25%", left: "-25%", width: "150%", height: "150%" }
            : { display: "none" }
        }
      >
        <video
          ref={this.videoEl}
          playsInline
          webkit-playsinline="true"
          controls
          preload="none"
          width="100%"
          height="100%"
          style={{ objectFit: "cover" }}
        >
          {this.state.currentVideoURL && <source src={this.state.currentVideoURL} type="video/mp4" />}
        </video>
        <a href="#" onClick={this.closeModalVideo} className="closeVideoModal">
          <img width={40} height={40} src={close} />
        </a>
      </div>
    );
  }
}

export default ModalVideo;
